import React, { useEffect, createElement } from 'react';
const PIXEL_ID = '1050452867254949';
declare global {
  interface Window {
    fbq?: ((...args: unknown[]) => void) & {
      callMethod?: (...args: unknown[]) => void;
      queue?: unknown[][];
      push?: unknown;
      loaded?: boolean;
      version?: string;
    };
    _fbq?: Window['fbq'];
  }
}
/**
 * Helper to track custom Meta Pixel events from anywhere in the app.
 * Safe to call before the pixel finishes loading — events will queue.
 */
export function trackPixelEvent(eventName: string, params?: Record<string, unknown>) {
  if (typeof window !== 'undefined' && typeof window.fbq === 'function') {
    if (params) {
      window.fbq('track', eventName, params);
    } else {
      window.fbq('track', eventName);
    }
  }
}
export function MetaPixel() {
  useEffect(() => {
    if (typeof window === 'undefined' || typeof document === 'undefined') {
      return;
    }
    // Initialize the fbq stub if it doesn't exist yet so calls can queue
    if (!window.fbq) {
      /* eslint-disable */
      const n: any = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      window.fbq = n;
      window._fbq = n;
      /* eslint-enable */
      // Inject the official fbevents.js loader (only once)
      const existing = document.getElementById('meta-pixel-script');
      if (!existing) {
        const script = document.createElement('script');
        script.id = 'meta-pixel-script';
        script.async = true;
        script.src = 'https://connect.facebook.net/en_US/fbevents.js';
        document.head.appendChild(script);
      }
    }
    if (typeof window.fbq === 'function') {
      window.fbq('init', PIXEL_ID);
      window.fbq('track', 'PageView');
    }
  }, []);
  return <noscript data-id="element-187" data-mp="263ie9smbj2eb">
      <img height="1" width="1" style={{
      display: 'none'
    }} src={`https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-188" data-mp="2641xrdrm9yug" />
    </noscript>;
}